module.exports = __webpack_public_path__ + "static/img/popup_coupon_defail@3x.9761498.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/popup_coupon_defail@3x.png
// module id = 1Fhg
// module chunks = 1